module.exports = __webpack_public_path__ + "img/logo-1@2x.0ae984d3.png";